"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../HBBanner/utils");
var _HBBanner = require("../HBBanner/HBBanner.styles");
var _useValidateBanner = require("../HBBanner/useValidateBanner");
var _useWindowSize2 = require("../common/useWindowSize");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _BannerActions = _interopRequireDefault(require("./BannerActions"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBBannerBase = function HBBannerBase(props) {
  var className = props.className,
    testIdName = props.testIdName,
    testId = props.testId,
    title = props.title,
    content = props.content,
    primaryAction = props.primaryAction,
    secondaryAction = props.secondaryAction,
    _props$primaryActionT = props.primaryActionTheme,
    primaryActionTheme = _props$primaryActionT === void 0 ? 'primary' : _props$primaryActionT,
    width = props.width,
    hideIcon = props.hideIcon,
    onClose = props.onClose,
    topPadding = props.topPadding,
    margin = props.margin,
    _props$whiteBanner = props.whiteBanner,
    whiteBanner = _props$whiteBanner === void 0 ? false : _props$whiteBanner,
    accentLine = props.accentLine,
    background = props.background,
    icon = props.icon,
    actionTextTransform = props.actionTextTransform,
    setActionsInline = props.setActionsInline,
    _props$actionsTheme = props.actionsTheme,
    actionsTheme = _props$actionsTheme === void 0 ? 'primary' : _props$actionsTheme,
    zIndex = props.zIndex,
    gradientBorderWidth = props.gradientBorderWidth,
    titleSuffix = props.titleSuffix;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isMultiLineDesign = _useState2[0],
    setIsMultiLineDesign = _useState2[1];
  var containerRef = (0, _react.useRef)(null);
  var textContainerRef = (0, _react.useRef)(null);
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isMediumUp = _useWindowSize.isMediumUp;
  (0, _useValidateBanner.useValidateBanner)({
    actionsTheme: actionsTheme,
    primaryAction: primaryAction,
    secondaryAction: secondaryAction
  });
  var hasIcon = icon && !hideIcon;
  (0, _react.useEffect)(function () {
    function calculateLineBreak() {
      if (setActionsInline === undefined) {
        if (textContainerRef.current) {
          if (title || titleSuffix) {
            setIsMultiLineDesign(true);
          } else {
            setIsMultiLineDesign((0, _utils.isBreakingLine)(content, textContainerRef.current));
          }
        }
      } else {
        setIsMultiLineDesign(!setActionsInline);
      }
    }
    calculateLineBreak();
    window.addEventListener('resize', calculateLineBreak);
    return function () {
      window.removeEventListener('resize', calculateLineBreak);
    };
  }, [content, setActionsInline, title, titleSuffix]);
  var BannerIcon = function BannerIcon() {
    var Icon = icon;
    return /*#__PURE__*/_react["default"].createElement(_HBBanner.IconContainer, null, /*#__PURE__*/_react["default"].createElement(Icon, {
      useDefaultFill: true
    }));
  };
  var enableCloseButton = !!onClose;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'banner',
    componentName: 'HBBannerBase'
  });
  return /*#__PURE__*/_react["default"].createElement(_HBBanner.BannerContainer, {
    className: className,
    ref: containerRef,
    hasIcon: hasIcon,
    width: width,
    margin: margin,
    topPadding: topPadding,
    whiteBanner: whiteBanner,
    accentLine: accentLine,
    background: background,
    isMultiLineDesign: isMultiLineDesign,
    enableCloseButton: enableCloseButton,
    "data-testid": finalTestId,
    zIndex: zIndex,
    gradientBorderWidth: gradientBorderWidth
  }, enableCloseButton && /*#__PURE__*/_react["default"].createElement(_HBBanner.Close, {
    "data-testid": "hb-banner-close--button",
    color: _colors["default"].neutral800,
    onClick: onClose,
    $isMultiLineDesign: isMultiLineDesign
  }), /*#__PURE__*/_react["default"].createElement(_HBBanner.Container, {
    paddingLeft: accentLine.includes('gradient') ? '4px' : '0' //add padding if the accent line is a gradient because the gradient is not part of the border
  }, hasIcon && /*#__PURE__*/_react["default"].createElement(BannerIcon, null), /*#__PURE__*/_react["default"].createElement(_HBBanner.TextContainer, null, (title || titleSuffix) && /*#__PURE__*/_react["default"].createElement(_HBBanner.StyledTopRow, null, title && /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "emphasis16",
    color: "neutral900"
  }, title), titleSuffix && titleSuffix), /*#__PURE__*/_react["default"].createElement(_HBBanner.Content, {
    type: "body14",
    color: "neutral900",
    ref: textContainerRef
  }, content))), /*#__PURE__*/_react["default"].createElement(_BannerActions["default"], {
    align: "end",
    testId: finalTestId,
    actionsTheme: actionsTheme,
    actionsSize: isMediumUp ? 'xs' : 'md',
    primaryAction: primaryAction,
    primaryActionTheme: primaryActionTheme,
    secondaryAction: secondaryAction,
    actionTextTransform: actionTextTransform
  }));
};
var _default = exports["default"] = HBBannerBase;
//# sourceMappingURL=HBBannerBase.js.map